<div class="viewer-container">
  <iframe 
    [src]="urlViewer" 
    frameborder="0" 
    style="width: 100%; height: 100%; border: none;"
    allowfullscreen
    loading="lazy">
  </iframe>
</div>
